import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { ScanIcon, RepairsIcon, QualityControlIcon2 } from 'ui-component/custom-icons/icons';


// ✅ Clear
const BreadcrumbsMobile = ({ current, activateTabsUsingId, referenceNumber, isCompleted = false }) => {
    const history = useNavigate();
    const isDisabled = !activateTabsUsingId;

    return (
        <div style={{ display: 'flex', gap: 10, justifyContent: 'space-evenly', padding: '10px 20px', alignItems: 'center' }}>
            <div style={{ position: 'relative' }}>
                <div
                    className={`new-breadcrumbs-btn-actions`}
                    style={{
                        opacity: isDisabled ? 0.5 : 1,
                        pointerEvents: isDisabled ? 'none' : 'auto',
                        cursor: isDisabled ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                        if (!isCompleted && !isDisabled) {
                            history(`/operations/edit/${activateTabsUsingId}/inbound`);
                        }
                    }}
                >
                    <ScanIcon height={'15px'} width={'15px'} />
                    Inbounding
                </div>
            </div>
            <FiChevronRight size={14} />
            <div style={{ position: 'relative' }}>
                <div
                    className={`new-breadcrumbs-btn-actions`}
                    style={{
                        opacity: isDisabled ? 0.5 : 1,
                        pointerEvents: isDisabled ? 'none' : 'auto',
                        cursor: isDisabled ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                        if (!isDisabled) {
                            history(`/operations/view/${activateTabsUsingId}/qualitycontrol`);
                        }
                    }}
                >
                    <QualityControlIcon2 height={'15px'} width={'15px'} />
                    Quality Control
                </div>
            </div>
            <FiChevronRight size={14} />
            <div style={{ position: 'relative' }}>
                <div
                    className={`new-breadcrumbs-btn-actions`}
                    style={{
                        opacity: isDisabled ? 0.5 : 1,
                        pointerEvents: isDisabled ? 'none' : 'auto',
                        cursor: isDisabled ? 'not-allowed' : 'pointer'
                    }}
                    onClick={() => {
                        if (!isDisabled) {
                            history(`/operations/view/${activateTabsUsingId}/repairs`);
                        }
                    }}
                >
                    <RepairsIcon height={'18px'} width={'18px'} />
                    Repairs
                </div>
            </div>
        </div>
    );
};

export default BreadcrumbsMobile;
